module.exports = __webpack_public_path__ + "img/ch07_07_窗外流光.9a18c614.jpg";